/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default memo(function Index({ employeesPerLocations }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);
  useEffect(() => {
    let locationData = {};
    if (employeesPerLocations?.length) {
      locationData = {
        datasets: [
          {
            data: employeesPerLocations?.map((item) => item?.count) || [],
            backgroundColor:
              employeesPerLocations?.map((item) => item?.backgroundColor) || [],
            hoverOffset: 4
          }
        ],
        labels: employeesPerLocations.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };
    }
    setGraphData(locationData);
  }, [employeesPerLocations]);

  const sortedLegends = employeesPerLocations?.sort(
    ({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
  );
  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };
  return (
    <Graph
        graphData={graphData}
        legends={sortedLegends}
        title={t("Répartition par bureau")}
        spaceLegende="arh-space-y-2"
        customOptions={customOptions}
        chartRef={chartRef}
  />
  );
});
